export class AjaxMappingBuilder {
    constructor() {
        this._paths = {
            data: '',
            total: null,
            filtered: null
        };
    }

    data(path) { this._paths.data = path; return this; }
    total(path) { this._paths.total = path; return this; }
    filtered(path) { this._paths.filtered = path; return this; }

    _resolve(json) {
        const getNested = (obj, path) => {
            if (!path) return obj;
            return path.split('.').reduce((acc, part) => acc && acc[part], obj);
        };

        const data = getNested(json, this._paths.data) || [];
        const recordsTotal = this._paths.total ? getNested(json, this._paths.total) : data.length;
        const recordsFiltered = this._paths.filtered ? getNested(json, this._paths.filtered) : recordsTotal;

        return {
            draw: json.draw,
            recordsTotal: recordsTotal,
            recordsFiltered: recordsFiltered,
            data: data
        };
    }
}
